// Čtení nativního HTML detailu pro rychlý náhled produktu (productPreviewModel.js).
export default {
  /** řádek „Kategorie" v doplňkových parametrech je navigace, ne parametr */
  skipParamRe: /^kategorie/i,
  /** hodnota variantního produktu („Zvolte variantu") — lže, nekreslí se */
  variantPlaceholderRe: /zvolte\s+variantu/i,
};
